"use client";

// packages/eden-text/src/components/Text4.jsx
import styled from "styled-components";
import shared from './shared.js';
import { jsx } from "react/jsx-runtime";
var Container4 = styled.div`
  font: var(--unity-text4-description);
  ${shared};
  ${({ $emphasized }) => $emphasized ? "font: var(--unity-text4-description-emphasized)" : ""};
`;
var Text4 = ({
  children,
  emphasized = false,
  renderAs = "div",
  ...props
}) => /* @__PURE__ */ jsx(Container4, { $emphasized: emphasized, as: renderAs, ...props, children });
Text4.displayName = "Text4";
var Text4_default = Text4;
export {
  Text4_default as default
};
